// Import model
import { PhoneNumber } from '../models/PhoneNumber';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PhoneNumber - handles JSON serialization and deserialization with type validation
 */
export class PhoneNumberSerializer {
  /**
   * Deserializes a JSON string into a PhoneNumber instance
   */
  static deserialize(json: string): PhoneNumber {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PhoneNumber instance
   */
  static fromObject(obj: any): PhoneNumber {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PhoneNumber');
    }


    const instance: PhoneNumber = {
      description: obj['description'] as string | undefined,
      phoneNumber: obj['phoneNumber'] as string | undefined,
      type_: obj['type'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PhoneNumber instances
   */
  static deserializeArray(json: string): PhoneNumber[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PhoneNumber instance to a JSON string
   */
  static serialize(instance: PhoneNumber): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PhoneNumber instance to a plain object
   */
  static toObject(instance: PhoneNumber): any {
    return {
      'description': instance.description,
      'phoneNumber': instance.phoneNumber,
      'type': instance.type_,
    };
  }

  /**
   * Serializes an array of PhoneNumber instances to a JSON string
   */
  static serializeArray(instances: PhoneNumber[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
